module.exports = __webpack_public_path__ + "img/tutorial-09.5312a38e.svg";